import { wrapApiCall } from '@/lib/axios'
import type { AxiosInstance } from 'axios'
import { deserialize } from 'ts-jackson'
import { AuditEvent, AuditEventFilter, AuditEventListResponse } from './model'

type RawListResponse = {
  data?: Record<string, unknown>[]
  truncated?: boolean
}

export const AuditLogService = (client: AxiosInstance) => {
  return {
    /**
     * Manager-facing audit trail. The backend windows the result (no offset
     * pagination): it returns up to `limit` newest events plus a `truncated`
     * flag, and the table paginates client-side within that window.
     */
    async getAuditEvents(filter: AuditEventFilter = {}): Promise<AuditEventListResponse> {
      const params = {
        from: filter.from,
        to: filter.to,
        level: filter.level,
        event_types: filter.eventTypes?.length ? filter.eventTypes.join(',') : undefined,
        actor_id: filter.actorId,
        actor_type: filter.actorType,
        branch_id: filter.branchId,
        limit: filter.limit,
      }
      const { data } = await wrapApiCall(() =>
        client.get<RawListResponse>('/audit-logs', { params })
      )
      return {
        data: (data?.data ?? []).map((item) => deserialize(item, AuditEvent)),
        truncated: !!data?.truncated,
      }
    },
  }
}
